import { GetUserDetailsResponse } from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { i18next } from '@frontend/i18n';
import { getFullName } from '@frontend/name';

export const getPersonName = (
  patient: Person | null,
  sender: 'AI Receptionist' | GetUserDetailsResponse | undefined
): string => {
  if (patient || (sender && typeof sender !== 'string')) {
    return getFullName((patient ?? sender) as Person);
  } else if (sender === 'AI Receptionist') {
    return sender;
  }

  return i18next.t('Unknown User', { ns: 'message-insights' });
};
